import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (zone) =>
    present(
      repository
        .deleteZone(zone)
        .then(() => zone)
        .catch(() => Promise.reject(zone)),
    );
}

export type { Interactor };

export { createInteractor };
